import { NotificationMessage } from './notification-message.model'

/**
 * v3 flat WebAlert wire (contract §4: no `type`, has `id` + `event` name + `status`).
 * Deep-link fields (`eventLogId`, `entityTeam`, `eventId`) are inline (Q12); `eventId` is null on v3.
 */
export interface WebAlert {
  id: string | number
  event: string
  status: string
  subject?: string
  body?: string
  ts?: string | number
  isRead?: boolean
  recipient?: string
  userId?: number
  vehicleId?: number
  deviceId?: number
  importance?: string
  eventLogId?: number
  entityTeam?: { id: number; type?: string }
  eventId?: number | null
}

/**
 * Flat WebAlert -> existing NotificationMessage: `body`->`message`, `ts`->`occurrenceTime`,
 * and the inline deep-link fields folded into the nested `event` object the panel expects.
 */
export function normalizeWebAlert(raw: WebAlert): NotificationMessage {
  const ts = raw?.ts ?? ''

  return {
    id: String(raw?.id ?? ''),
    recipient: raw?.recipient ?? '',
    subject: raw?.subject ?? '',
    message: raw?.body ?? '',
    // a realtime push is a fresh arrival — always unread (also avoids showNotification()'s
    // empty-array deref when the popup path filters out an already-read frame).
    isRead: false,
    sendingTime: ts,
    occurrenceTime: ts,
    acknowledge: null,
    event: {
      vehicleId: raw?.vehicleId,
      deviceId: raw?.deviceId,
      userId: raw?.userId,
      entityTeam: raw?.entityTeam,
      eventLogId: raw?.eventLogId,
      eventId: raw?.eventId,
    },
  } as unknown as NotificationMessage
}
